/* eslint no-async-promise-executor: 0 */
// import { versaoDeDadosServidor } from "../services/vex/versaoDeDados"
import versaoDeDadosServidor from "@/services/vex/versaoDeDados";

class VersaoDeDados {
    async versaoDeDadosAtualizada() {
        let versaoServidor = await versaoDeDadosServidor();
        let versaoLocal = JSON.parse(localStorage.getItem("versaoDeDados"));
        let atualizada = versaoServidor == versaoLocal;
        return atualizada;
    }

    async setVersaoDadosLocal() {
        let versaoServidor = await versaoDeDadosServidor();
        localStorage.setItem("versaoDeDados", versaoServidor.toString());
        return "Ok";
    }
}
export default VersaoDeDados;
